import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { getApiErrorToast } from "./Consts";
import { getErrorStatus } from "../Services/getErrorStatus";

type ApiError =
  | boolean
  | { status?: number; response?: { status?: number } }
  | any[];

type ToastOverride = { title: string; description: string };

export function showApiErrorToast(
  error: ApiError,
  isSearch = false,
  override?: ToastOverride
) {
  if (!error) return;

  const status = typeof error === "object" ? getErrorStatus(error) : undefined;

  const errorToast = override ?? getApiErrorToast(status, isSearch);

  toast.error(errorToast.title, {
    description: errorToast.description,
    duration: 3000,
  });
}

export function useApiErrorToast(
  error: ApiError,
  isSearch = false,
  override?: ToastOverride
) {
  const lastNotifiedError = useRef<ApiError>(false);
  const title = override?.title;
  const description = override?.description;

  useEffect(() => {
    if (!error || error === lastNotifiedError.current) return;

    lastNotifiedError.current = error;
    showApiErrorToast(
      error,
      isSearch,
      title !== undefined && description !== undefined
        ? { title, description }
        : undefined
    );
  }, [error, isSearch, title, description]);
}
